import React from 'react';
import loadingImg from '../assets/gears.svg';
import styled from 'styled-components';

const LoadingSpinnerImg = styled.img`
  max-width: 100%;
  margin: 0 auto;
  display: block;
`;

const LoadingSpinner = () => (
  <LoadingSpinnerImg src={loadingImg} alt="Loading, please wait..." />
);

export default LoadingSpinner;
